
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Box, Typography, Paper, Chip, styled } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import HeaderTabs from "../components/HeaderTabs";
// import CheckedInvoicesTable from "../components/CheckedInvoices/CheckedInvoicesTable";

const AiBadge = styled(Chip)(({ theme }) => ({
  backgroundColor: "#0563B0",
  color: "white",
  fontWeight: 500,
  padding: "0 12px",
  height: "32px",
  "& .MuiSvgIcon-root": {
    fontSize: "1.2rem",
    color: "white",
  },
  "& .MuiChip-icon": {
    color: "white",
  },
  borderRadius: "16px",
  boxShadow: "0 2px 8px rgba(5, 99, 176, 0.15)",
}));

function CheckInvoices() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Set initial tab value based on current path
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('checked')) setValue(0);
    else if (path.includes('upload')) setValue(1);
    else if (path.includes('pricelist')) setValue(2);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate('/CheckInvoices/checked');
        break;
      case 1:
        navigate('/CheckInvoices/upload');
        break;
      case 2:
        navigate('/CheckInvoices/pricelist');
        break;
      default:
        break;
    }
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <HeaderTabs
          tabValue={value}
          handleTabChange={handleChange}
          labels={["חשבוניות שנבדקו", "בדיקת מסמכים", "מחירונים"]}
        />
      </Box>
      <Box
        sx={{
          bgcolor: "#ebf7ff",
          p: 2,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <SmartToyIcon sx={{ color: "#0563B0" }} />
          <Typography variant="body2" color="#0563B0">
            הבדיקות בוצעו על ידי מערכת בינה מלאכותית ויכולות לכלול אי-דיוקים.
            אנו ממליצים לאמת את התוצאות
          </Typography>
        </Box>
        <AiBadge label="AI-Powered" sx={{ flexShrink: 0 }} />
      </Box>
      
      <Box sx={{ mt: 3, width: "100%" }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "white",
            width: "100%",
          }}
        >
          <Outlet />
        </Paper>
      </Box>
    </Box>
  );
}

export default CheckInvoices;